import React from 'react';
import PageBuilderAdmin from './PageBuilderAdmin';


const PageBuilderPage: React.FC = () => {
    return <PageBuilderAdmin />;
};

export default PageBuilderPage;